/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import {
  SnackbarProvider as NotistackProvider,
  SnackbarProviderProps,
} from 'notistack';

import styles from './styles';

type PropTypes = SnackbarProviderProps;

const SnackbarProvider: React.FC<PropTypes> = props => {
  return (
    <NotistackProvider
      css={styles}
      hideIconVariant
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  );
};

export default SnackbarProvider;
